var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-navigation"},[_c('app-common-menu',{attrs:{"personal-menu":_vm.personalMenu}}),_vm._v(" "),_c('app-personal-menu',{attrs:{"personal-menu":_vm.personalMenu,"time":_vm.time}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }